import Logo from './Logo';

const CheckoutInner = (props) => {
  const { children, settings } = props;
  if (!settings) {
    return (
      <div className="c7-checkout__main c7-checkout__main--wide">
        <div className="c7-checkout__header">&nbsp;</div>
        {children}
      </div>
    );
  }
  return (
    <div className="c7-checkout__main c7-checkout__main--wide">
      <div className="c7-checkout__header">
        <Logo />
      </div>
      {children}
    </div>
  );
};
export default CheckoutInner;
